import { useParams } from 'react-router-dom'

import { useCurrentWorkspace } from '../store/hooks'
import { SceneContainer } from '../components/scene/SceneContainer'
import { DocumentRepository } from '../components/documents/DocumentRepository'
import { WorkspaceNotFound } from '../components/workspace/WorkspaceNotFound'

const WorkspaceDocumentRepositoryScreen = () => {
  const { workspaceId } = useParams<{ workspaceId: string }>()

  const { workspace } = useCurrentWorkspace(workspaceId)

  if (!workspace || !workspaceId) {
    return <WorkspaceNotFound workspaceId={workspaceId} />
  }

  return (
    <SceneContainer
      title="Documents"
      description="View and manage your documents"
    >
      <DocumentRepository
        workspaceId={workspaceId}
        accountingReferenceDate={workspace.calendarYearEndReferenceDate}
      />
    </SceneContainer>
  )
}

export default WorkspaceDocumentRepositoryScreen
